import { cn } from '@/lib/utils';

interface MetricChipProps {
  metricKey: string;
  label?: string;
  onClick?: (metricKey: string) => void;
}

export const MetricChip = ({ metricKey, label, onClick }: MetricChipProps) => {
  const displayLabel = label ?? metricKey;
  const isClickable = !!onClick;

  return (
    <button
      type="button"
      onClick={() => onClick?.(metricKey)}
      disabled={!isClickable}
      className={cn(
        'mx-0.5 inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium',
        isClickable
          ? 'border-blue-300 bg-blue-50 text-blue-700 hover:bg-blue-100 dark:border-blue-700 dark:bg-blue-950/50 dark:text-blue-300 dark:hover:bg-blue-900/50'
          : 'border-slate-300 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400',
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      {displayLabel}
    </button>
  );
};
